import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Radio, Upload, Divider, Form, Input } from 'antd';
import { TagOutlined, UploadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useQuotesContext from './QuotesContext';

const { TextArea } = Input;

const RcngawkExemptionModal = ({
  setFile,
  open,
  setVisible,
  openModal,
  setModalExemption
}) => {
  const { setAnalyzeModalVisible } = useQuotesContext();
  const { t } = useTranslation();

  // Function when the modal is closing with OK
  const handleModalSubmit = () => {
    setAnalyzeModalVisible(true);
    setVisible(false);
  };

  // Function when the modal is closing with CANCEL
  const handleModalClose = () => {
    setModalExemption(false);
    setFile([]);
    setVisible(false);
  };

  const handleUpload = (doc) => {
    setFile((prevFile) => [...prevFile, doc]);
  };

  const handleRemove = (doc) => {
    setFile((prevFile) => prevFile.filter((f) => f.doc !== doc));
  };

  return (
    <>
      <Button
        onClick={() => {
          setModalExemption(true);
          openModal();
        }}
        className="exemption-button"
        type="primary"
      >
        {`${t('buttons.save_personalized_quote')} `}
        <TagOutlined />
      </Button>
      <Modal
        title={`${t('buttons.save_rcnga_quote')}`}
        open={open}
        onOk={() => handleModalSubmit()}
        onCancel={() => handleModalClose()}
        width={1000}
        closable={false}
      >
        <p style={{ fontWeight: 700 }}>{t('help.rcngawk_request')}</p>
        <Form.Item name="comment">
          <TextArea
            required
            placeholder={t('placeholder.request_object')}
            maxLength={3000}
            style={{ height: 150, marginBottom: 8 }}
          />
        </Form.Item>
        <Divider />
        <p style={{ fontWeight: 700 }}>{t('buttons.upload_rcngawk_ask')}</p>
        <Upload
          maxCount={2}
          beforeUpload={(doc) => {
            handleUpload(doc);
            return false;
          }}
          onRemove={() => {
            handleRemove();
          }}
        >
          <Button icon={<UploadOutlined />}>
            {t('contractDocuments.kbis')}
          </Button>
        </Upload>
        <Upload
          maxCount={2}
          beforeUpload={(doc) => {
            handleUpload(doc);
            return false;
          }}
          onRemove={() => {
            handleRemove();
          }}
        >
          <Button icon={<UploadOutlined />}>
            {t('contractDocuments.customerCni')}
          </Button>
        </Upload>
        <Upload
          maxCount={2}
          beforeUpload={(doc) => {
            handleUpload(doc);
            return false;
          }}
          onRemove={() => {
            handleRemove();
          }}
        >
          <Button icon={<UploadOutlined />}>
            {t('contractDocuments.rib')}
          </Button>
        </Upload>
        <Upload
          maxCount={2}
          beforeUpload={(doc) => {
            handleUpload(doc);
            return false;
          }}
          onRemove={() => {
            handleRemove();
          }}
        >
          <Button icon={<UploadOutlined />}>
            {t('contractDocuments.informationsReport')}
          </Button>
        </Upload>
        <Upload
          maxCount={2}
          beforeUpload={(doc) => {
            handleUpload(doc);
            return false;
          }}
          onRemove={() => {
            handleRemove();
          }}
        >
          <Button icon={<UploadOutlined />}>
            {t('contractDocuments.drivingLicense')}
          </Button>
        </Upload>
        <Upload
          maxCount={2}
          beforeUpload={(doc) => {
            handleUpload(doc);
            return false;
          }}
          onRemove={() => handleRemove()}
        >
          <Button icon={<UploadOutlined />}>
            {t('contractDocuments.vehicleRegistration')}
          </Button>
        </Upload>
        <Divider />
        <p style={{ fontWeight: 700 }}>{t('tasks.form.answer_delay')}</p>
        <Form.Item name="answerDelay">
          <Radio.Group style={{ flexFlow: 'row wrap' }} defaultValue="HIGH">
            <Radio value="URGENT">{t('exemptions_delay.very_urgent')}</Radio>
            <Radio value="HIGH">{t('exemptions_delay.urgent')}</Radio>
            <Radio value="NORMAL">{t('exemptions_delay.not_urgent')}</Radio>
            <Radio disabled value={t('exemptions_delay.more_than')}>
              {t('exemptions_delay.more_than')}
            </Radio>
          </Radio.Group>
        </Form.Item>
      </Modal>
    </>
  );
};

RcngawkExemptionModal.propTypes = {
  form: PropTypes.shape({
    validateFields: PropTypes.func,
    scrollToField: PropTypes.func,
    setFieldsValue: PropTypes.func
  }).isRequired,
  setFile: PropTypes.func.isRequired,
  setVisible: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  setModalExemption: PropTypes.func.isRequired
};

export default RcngawkExemptionModal;
